import ConfirmationModal from "@components/modals/ConfirmationModal/ConfirmationModal";
import { createContext, useContext, useState } from "react";

type CallbackType = () => void;
export type ConfirmationOptionsType = {
    description?: string,
};

type ConfirmationContextType = {
    isConfirmationModalOpened: boolean,
    openConfirmationModal: (title: string, callback?: CallbackType, options?: ConfirmationOptionsType) => void,
    closeConfirmationModal: () => void,
};

export const ConfirmationContext = createContext<ConfirmationContextType>({
    isConfirmationModalOpened: false,
    openConfirmationModal: (title: string, callback?: CallbackType, options?: ConfirmationOptionsType) => {},
    closeConfirmationModal: () => {},
});

export const useConfirmationContext = () => {
    return useContext(ConfirmationContext);
};

type ConfirmationModalProviderProps = {
    children: React.ReactNode,
};

export function ConfirmationModalProvider(props: ConfirmationModalProviderProps) {

    const [confirmationTitle, setConfirmationTitle] = useState<string>('');
    const [confirmationOptions, setConfirmationOptions] = useState<ConfirmationOptionsType>({});
    const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);
    const [confirmationCallback, setConfirmationCallback] = useState<CallbackType|null>(null);

    const handleOpenConfirmationModal = (title: string, callback?: CallbackType, options?: ConfirmationOptionsType): void => {
        setConfirmationTitle(title);
        if(callback) {
            setConfirmationCallback(() => callback);
        }
        if(options) {
            setConfirmationOptions(options);
        }
        setConfirmationVisible(true);
    };

    const handleCloseConfirmationModal = (): void => {
        setConfirmationCallback(null);
        setConfirmationOptions({});
        setConfirmationVisible(false);
    };

    const handleAccept = (): void => {
        if(confirmationCallback) {
            confirmationCallback();
        }
    };

    return (
        <ConfirmationContext.Provider value={{
            isConfirmationModalOpened: false,
            openConfirmationModal: handleOpenConfirmationModal,
            closeConfirmationModal: handleCloseConfirmationModal,
        }}>
            <ConfirmationModal visible={confirmationVisible} onHide={handleCloseConfirmationModal} title={confirmationTitle} options={confirmationOptions} onAccept={handleAccept}/>
            {props.children}
        </ConfirmationContext.Provider>
    );
}
